// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"RelaysNav","95":"MapSingle","316":"MapSummary","429":"JobQueue","776":"RelaysResultTable"}[chunkId] + "." + {"94":"c2dbda74","95":"a9601ca7","316":"5ae200df","429":"132da988","776":"fb09639c"}[chunkId] + ".css";
};